export enum PREVIEW_PRODUCT_TYPES {
  FRAME = 'FRAME',
  CANVAS = 'CANVAS',
  LEGER = 'LEGER',
  PHOTO_CLASSIC = 'SMALL_SIZE',
  POSTER = 'LARGE_SIZE',
  PHOTO_CLASSIC_WITH_BORDER = 'SMALL_SIZE_WITH_BORDER',
  PHOTO_PANORAMIC = 'PANORAMIC_SIZE',
  PHOTO_VINTAGE = 'VINTAGE',
  FRAME_ADHESIVE = 'FRAME_ADHESIVE',
}
